import { IconContext } from '@phosphor-icons/react';
import type { PropsWithChildren } from 'react';

export const IconsProvider = ({ children }: PropsWithChildren) => {
    return (
        <IconContext.Provider
            value={{
                color: 'currentColor',
                size: 24,
            }}
        >
            {children}
        </IconContext.Provider>
    );
};
